import { useSelector } from 'react-redux';

import { RootState } from 'redux/rootReducer';
import { ICustomer } from 'redux/reducers/customers';
import { IPlaylistItem } from '../components/PlaylistTableRow';
import playlistCustomers from 'maps/customer-name-id';

const useCustomerName = (playlist: IPlaylistItem): string => {
  const customers = useSelector((state: RootState) => state.customers.data);
  const customerId =
    typeof playlist.customerId === 'number'
      ? Object.keys(playlistCustomers).find(
          (key) => playlistCustomers[key] === playlist.customerId
        )
      : playlist.customerId;
  const currentCustomer = customers.filter(
    (customer: ICustomer) =>
      customer.name === customerId && customer.feedType === 'streaming'
  );
  return (currentCustomer.length > 0 && currentCustomer[0].displayName) || '';
};

export default useCustomerName;
